import { useEffect, useState } from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { CustomEvents } from 'shared/constants/customEvents'
import { INNOSCRIPTA_INTERNAL_ORGANIZATION_ID } from 'shared/constants/user'
import { useUserContext } from 'shared/hooks'
import { listenCustomEvent } from 'shared/utils/customEvents'

export const NewGrantApplicationModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useUserContext()

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_FEEDBACK_APP_DEV_PATH,
    'feedback',
    './NewGrantApplicationModal',
    'feedbackApp',
    false,
    process.env.REACT_APP_FEEDBACK_APP_CDN_URL
  )

  // @ts-expect-error: dynamic import
  const { NewGrantApplicationModal: FeedbackNewGrantApplicationModal } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { NewGrantApplicationModal: () => null }

  useEffect(
    () =>
      listenCustomEvent(CustomEvents.OPEN_NEW_GRANT_APPLICATION_MODAL, () =>
        setIsOpen(true)
      ),
    []
  )

  const isInternalUser =
    user?.organization_id === INNOSCRIPTA_INTERNAL_ORGANIZATION_ID

  return (
    <FeedbackNewGrantApplicationModal
      isOpen={isOpen && !isInternalUser}
      onClose={() => setIsOpen(false)}
    />
  )
}
